var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartBnpl = function SvgCartBnpl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 44 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "M2.643 6.407H6.63l1.083 4.114.029.097 2.766 13.843q.011.113.034.223l1.2 6v.008a3.57 3.57 0 0 0 3.5 2.858h17.4a2.143 2.143 0 0 0 0-4.286H15.829l-.715-3.572h19.989c.1 0 .386.01.648-.034a2.89 2.89 0 0 0 2.16-1.683c.155-.354.232-.803.258-.951l.008-.04 2.26-11.034.006-.029a2.86 2.86 0 0 0-2.8-3.371h-26.02l-.952-3.643A3.57 3.57 0 0 0 7.186 2.12H2.643a2.143 2.143 0 0 0 0 4.286",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M19.443 38.693a3.283 3.283 0 1 0-6.566 0 3.282 3.282 0 0 0 6.563 0zm14.285 0a3.283 3.283 0 0 0-6.565 0 3.283 3.283 0 0 0 6.562 0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#52585D",
    fillRule: "evenodd",
    d: "M27.75.121a1.5 1.5 0 0 1 1.5 1.5v1.5h7.5v-1.5a1.5 1.5 0 1 1 3 0v1.5h1.5a2.25 2.25 0 0 1 2.25 2.25v1.5h-21v-1.5a2.25 2.25 0 0 1 2.25-2.25h1.5v-1.5a1.5 1.5 0 0 1 1.5-1.5",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M22.5 6.871h21v12a2.25 2.25 0 0 1-2.25 2.25h-16.5a2.25 2.25 0 0 1-2.25-2.25z"
  })));
};
export default SvgCartBnpl;